/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-unused-prop-types */
import React from 'react'
import { Button, MenuItem, Popover, Select, TextField } from '@mui/material'
import SwitchContainer from 'components/SwitchContainer'
import CustomSwitch from 'components/CustomSwitch'
import styles from './styles'

const AdvancedFiltersPopover = ({ open, onClose, anchorEl, filterValues, changeFilterValue }) => {
  const classes = styles()

  const handleOnChangeInitDate = (event) => {
    changeFilterValue({ initDate: event.target.value })
  }

  const handleOnChangeEndDate = (event) => {
    changeFilterValue({ endDate: event.target.value })
  }

  const handleChangeShowEmptyApplications = (event) => {
    changeFilterValue({ showEmptyApplications: event.target.checked })
  }

  const handleChangeShowWaitingClarification = (event) => {
    const { value } = event.target
    changeFilterValue({ showWaitingClarification: value })
  }
  const handleChangeStatus = (event) => {
    const { value } = event.target
    changeFilterValue({ status: value })
  }
  const handleChangeResult = (event) => {
    const { value } = event.target
    changeFilterValue({ result: value })
  }

  const bulidStatusFilter = () => (
    <div className={classes.filterRow}>
      <div>Status</div>
      <Select
        labelId="status"
        id="status "
        value={filterValues.status}
        onChange={handleChangeStatus}
        autoWidth
        variant="standard"
        className={classes.select}
      >
        <MenuItem className={classes.menuItem} value="ALL">
          Todos
        </MenuItem>
        <MenuItem className={classes.menuItem} value="CREATED">
          Aplicação Iniciada
        </MenuItem>
        <MenuItem className={classes.menuItem} value="BGC_PROCESSING">
          Processando BGC
        </MenuItem>
        <MenuItem className={classes.menuItem} value="WAITING_REVIEW">
          Aguardando revisão
        </MenuItem>
        <MenuItem className={classes.menuItem} value="WAITING_REVIEW_FOR_ROLE">
          Aguardando revisão (minha área)
        </MenuItem>
        <MenuItem className={classes.menuItem} value="BGC_PROCESSED_MISSING_CREDIT_ANALYSIS">
          Concluído sem a Análise de Crédito
        </MenuItem>
        <MenuItem className={classes.menuItem} value="FINISHED">
          Concluído
        </MenuItem>
      </Select>
    </div>
  )

  const buildResultFilter = () => (
    <div className={classes.filterRow}>
      <div>Resultado</div>

      {/* <InputLabel id="result">Status:</InputLabel> */}
      <Select
        labelId="result"
        id="result"
        value={filterValues.result}
        onChange={handleChangeResult}
        autoWidth
        variant="standard"
        className={classes.select}
      >
        <MenuItem className={classes.menuItem} value="ALL">
          Todos
        </MenuItem>
        <MenuItem className={classes.menuItem} value="APPROVED">
          Aprovados
        </MenuItem>
        <MenuItem className={classes.menuItem} value="REPROVED">
          Reprovados
        </MenuItem>
      </Select>
    </div>
  )

  return (
    <div id="popover" className={classes.filterButton}>
      <Popover
        open={open}
        onClose={onClose}
        anchorEl={anchorEl}
        elevation={1}
        classes={{ paper: classes.paperOverwrite }}
      >
        <div className={classes.filtersModal}>
          <h3>FILTROS</h3>

          <div>
            <div className={classes.filterRow}>
              <div style={{ width: '70%' }}>Aplicações sem Background Check</div>
              <SwitchContainer leftLabelText="ocultar" rightLabelText="exibir">
                <CustomSwitch
                  id="show-switch"
                  checked={filterValues.showEmptyApplications}
                  onChange={handleChangeShowEmptyApplications}
                />
              </SwitchContainer>
            </div>
          </div>

          <div>
            <div className={classes.filterRow}>{bulidStatusFilter()}</div>
          </div>

          <div>
            <div className={classes.filterRow}>{buildResultFilter()}</div>
          </div>

          <div>
            <div className={classes.filterRow}>
              <div style={{ width: '50%' }}>Aplicações com revisão<br/>aguardando esclarecimento</div>
              <Select
                labelId="status"
                id="status "
                value={filterValues.showWaitingClarification}
                onChange={handleChangeShowWaitingClarification}
                autoWidth
                variant="standard"
                className={classes.select}
              >
                <MenuItem className={classes.menuItem} value="ALL">
                  Mostrar todas
                </MenuItem>
                <MenuItem className={classes.menuItem} value="SHOW">
                  Somente as que têm
                </MenuItem>
                <MenuItem className={classes.menuItem} value="HIDE">
                  Somente as que não têm
                </MenuItem>
              </Select>
            </div>
          </div>

          <br></br>

          <div>
            <div className={classes.filterRow}>
              <TextField
                variant="standard"
                label="Data início:"
                type="date"
                defaultValue={filterValues.initDate}
                InputProps={{ style: { fontSize: '1.5rem' } }}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={handleOnChangeInitDate}
              />
              <TextField
                variant="standard"
                label="Data fim:"
                type="date"
                defaultValue={filterValues.endDate}
                InputProps={{ style: { fontSize: '1.5rem' } }}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={handleOnChangeEndDate}
              />
            </div>
          </div>

          <Button onClick={onClose}>
            <strong>Fechar</strong>
          </Button>
        </div>
      </Popover>
    </div>
  )
}

export default AdvancedFiltersPopover
